import React from 'react';
import { User } from 'interfaces/user.interface';
import { EventCommitment } from 'interfaces/types.interface';
import { StyleEventCard } from 'enum/styleEventCard.enum';
import EngagementLineCard from './engagementLineCard.component';
import EngagementSquareCard from './engagementSquareCard.component';

interface EngagementCardProps {
  engagement: EventCommitment;
  engagementIndex: number;
  dayStart?: Date;
  canDrag?: boolean;
  cursor?: string;
  themeHightlighted?: string;
  user?: User;
  rotation?: number;
  isDragging?: boolean;
  isHighlighted?: boolean;
  setIsDragging?: ( dragging: boolean ) => void;
  onEngagementClick?: ( task: EventCommitment ) => void;
  handleDragStart?: (
    e: React.DragEvent<HTMLDivElement>,
    task: EventCommitment,
    dayStartDrag: Date,
    user: User
  ) => void
  style: StyleEventCard;
}

const EngagementCard: React.FC<EngagementCardProps> = ( {
  engagement,
  themeHightlighted,
  engagementIndex,
  dayStart,
  rotation,
  canDrag,
  cursor = 'cursor-grab',
  user,
  isDragging,
  isHighlighted = false,
  setIsDragging,
  onEngagementClick,
  handleDragStart,
  style
} ) => {

  const getCardComponent = () => {
    let component = null;
    switch ( style ) {
    case StyleEventCard.line: component =
    <EngagementLineCard
      engagement={ engagement }
      themeHightlighted={ themeHightlighted }
      engagementIndex={ engagementIndex }
      dayStart={ dayStart }
      canDrag={ canDrag }
      cursor={ cursor }
      user={ user }
      isDragging={ isDragging }
      isHighlighted={ isHighlighted }
      setIsDragging={ setIsDragging }
      onEngagementClick={ onEngagementClick }
      handleDragStart={ handleDragStart }
    />;
      break;
    default: component =
    <EngagementSquareCard
      engagement={ engagement }
      themeHightlighted={ themeHightlighted }
      engagementIndex={ engagementIndex }
      dayStart={ dayStart }
      rotation={ rotation }
      canDrag={ canDrag }
      cursor={ cursor }
      user={ user }
      isDragging={ isDragging }
      isHighlighted={ isHighlighted }
      setIsDragging={ setIsDragging }
      onEngagementClick={ onEngagementClick }
      handleDragStart={ handleDragStart }
    />;
    }

    return component;
  };

  return (
    <>
      {
        getCardComponent()
      }
    </>
  );
};

export default EngagementCard;
